import { getBlockPay } from './blockWay.js';

/** 高级编辑器下单 type */
export const GEDIT_ORDER_TYPE = 4;

/** 全局支付条在下单 / 存档时的固定 o_id（后端据此识别全站解锁） */
export const GEDIT_GLOBAL_PAY_OID = '100';

/** 模块付费状态：1 已付 0 未付 */
export const GEDIT_PAY_STATUS_PAID = 1;

/** 全局支付条（非内容付费模块） */
export function isGeditGlobalPayBlock(type) {
	if (typeof type !== 'string' || !type.startsWith('pay-unlock')) return false;
	// 付费跳转组件（pay-unlock-jumplink*）属于独立的内容付费模块，单独识别
	if (type.startsWith('pay-unlock-jumplink')) return false;
	return true;
}

/** 付费跳转组件（用户付费后跳转外部链接） */
export function isGeditJumpLinkBlock(type) {
	return typeof type === 'string' && type.startsWith('pay-unlock-jumplink');
}

/**
 * 下单 / 查支付状态用的 o_id：组件类型固定 id（6 位数字），不是实例 uid。
 * 同 type 多实例共用同一 o_id。
 */
export function getBlockOId(block = {}) {
	if (block.id != null && block.id !== '') {
		return String(block.id);
	}
	return '';
}

/** 收集页面内内容付费模块 o_id（不含全局支付条） */
export function collectGeditPayOIds(blocks = []) {
	const ids = [];
	const seen = new Set();
	(Array.isArray(blocks) ? blocks : []).forEach((block) => {
		if (isGeditGlobalPayBlock(block.type)) return;
		if (getBlockPay(block.type) !== 1) return;
		const oId = getBlockOId(block);
		if (!oId || seen.has(oId)) return;
		seen.add(oId);
		ids.push(oId);
	});
	return ids;
}

/** 收集页面中尚未解锁的内容付费模块 o_id */
export function collectUnpaidGeditPayOIds(blocks = [], paidModules = {}) {
	return collectGeditPayOIds(blocks).filter((oId) => !paidModules?.[oId]);
}

/** 解析 o_id（支持 '100001,100002'） */
export function parseGeditPayOIds(oId = '') {
	return String(oId || '')
		.split(',')
		.map((item) => item.trim())
		.filter(Boolean);
}

/** 全局支付下单用的 o_id 字符串 */
export function buildGlobalPayOId(blocks = [], paidModules = {}) {
	return collectUnpaidGeditPayOIds(blocks, paidModules).join(',');
}

export function mapGeditPayStatusList(list = []) {
	const paid = {};
	(Array.isArray(list) ? list : []).forEach((item) => {
		const oId = item?.o_id;
		if (!oId) return;
		if (Number(item.pay_status) === GEDIT_PAY_STATUS_PAID) {
			paid[oId] = true;
		}
	});
	return paid;
}
